import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import agentService from "../../services/AgentService";
import { Agent } from "../../interfaces";
interface Agents {
  agents: Agent[];
  singleAgent?: Agent;
  error?: string | null;
  loading: boolean;
}

const initialState: Agents = {
  agents: [],
  singleAgent: {} as Agent,
  error: "",
  loading: false,
};

export const fetchAgents = createAsyncThunk(
  "agents/fetchAgents",
  async (_, { rejectWithValue }) => {
    try {
      const response = await agentService.getAll();
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export const fetchAgentById = createAsyncThunk(
  "agents/fetchAgentById",
  async (id: number) => {
    try {
      const response = await agentService.getById(id);
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export const addAgent = createAsyncThunk(
  "agents/addAgent",
  async (data: any) => {
    try {
      const response = await agentService.post(data);
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export const updateAgent = createAsyncThunk(
  "agents/updateAgent",
  async (data: any) => {
    try {
      const response = await agentService.put(data.id, {
        title: data.title,
        state: data.state,
        meta_data: data.meta_data,
        host: data.host,
        UUID: data.UUID,
        status: data.status,
      });
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export const deleteAgent = createAsyncThunk(
  "agents/deleteAgent",
  async (id: number) => {
    try {
      const response = await agentService.remove(id);
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

const agentSlice = createSlice({
  name: "agents",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAgents.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchAgents.fulfilled, (state, action) => {
      state.loading = false;
      state.agents = action.payload;
    });
    builder.addCase(fetchAgents.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });

    builder.addCase(fetchAgentById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchAgentById.fulfilled, (state, action) => {
      state.loading = false;
      state.singleAgent = action.payload;
    });
    builder.addCase(fetchAgentById.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
  },
});

const { reducer } = agentSlice;
export default reducer;
